import { createContext } from "react";

import { type MachineGroup } from "@/schemas/machine-group";
import { type ProductionGroup } from "@/schemas/production-group";

export interface ProductionGroupContextValue {
	changeProductionGroup: (machineGroup: MachineGroup, productionGroup: ProductionGroup) => void;
	removeMachineGroupFromProductionGroup: (machineGroup: MachineGroup) => void;
}

export const ProductionGroupContext = createContext<ProductionGroupContextValue>({
	changeProductionGroup: () => {},
	removeMachineGroupFromProductionGroup: () => {},
});
